import React from 'react';
import { NavLink } from 'react-router-dom';
import './Layout.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-links">
        <NavLink 
          to="/"
          className={({ isActive }) => isActive ? 'active' : ''}
          end
        >
          Calculadora
        </NavLink> | 
        <NavLink 
          to="/guia"
          className={({ isActive }) => isActive ? 'active' : ''}
        >
          Guia de Juros Compostos
        </NavLink> | 
        <NavLink 
          to="/politica-de-privacidade"
          className={({ isActive }) => isActive ? 'active' : ''}
        >
          Política de Privacidade
        </NavLink> | 
        <NavLink 
          to="/termos-de-uso"
          className={({ isActive }) => isActive ? 'active' : ''}
        >
          Termos de Uso
        </NavLink>
      </div>
      <div className="footer-bottom">
        <p>&copy; {currentYear} Calculadora de Juros Compostos. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;
